import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "places-top-matter" }
const _hoisted_2 = { class: "name" }
const _hoisted_3 = { class: "right-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackIcon = _resolveComponent("BackIcon")!
  const _component_NcActionButton = _resolveComponent("NcActionButton")!
  const _component_NcActions = _resolveComponent("NcActions")!
  const _component_UnassignedIcon = _resolveComponent("UnassignedIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.name)
      ? (_openBlock(), _createBlock(_component_NcActions, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_NcActionButton, {
              "aria-label": _ctx.t('memories', 'Back'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.back()))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_BackIcon, { size: 20 })
              ]),
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Back')) + " ", 1)
              ]),
              _: 1
            }, 8, ["aria-label"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.name || _ctx.viewname), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_NcActions, { inline: 0 }, {
        default: _withCtx(() => [
          (!_ctx.name && !_ctx.routeIsPlacesUnassigned)
            ? (_openBlock(), _createBlock(_component_NcActionButton, {
                key: 0,
                "aria-label": _ctx.t('memories', 'Files without location'),
                onClick: _ctx.openUnassigned,
                "close-after-click": ""
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_UnassignedIcon, { size: 20 })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('memories', 'Files without location')) + " ", 1)
                ]),
                _: 1
              }, 8, ["aria-label", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}